var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("AlternativeEditorDialog", {
        attrs: { viewModel: _vm.alternativeEditorDialog },
      }),
      _vm._v(" "),
      _c("AlternativesComparisonDialog", {
        attrs: { viewModel: _vm.alternativesComparisonDialog },
      }),
      _vm._v(" "),
      _c("ViewSettingsEditor", {
        attrs: { viewModel: _vm.viewSettingsEditor },
        on: { saved: _vm.onViewSettingsUpdated },
      }),
      _vm._v(" "),
      _c("ListSelectionDialog", {
        attrs: { viewModel: _vm.statusListSelectionDialog },
        on: {
          "update-value": _vm.handleUpdateMultipleAlternativesStatusCommand,
        },
      }),
      _vm._v(" "),
      _c("ListSelectionDialog", {
        attrs: { viewModel: _vm.attrListSelectionDialog },
        on: {
          "update-value":
            _vm.handleMultipleAlternativesAttributeValueUpdateCommand,
        },
      }),
      _vm._v(" "),
      _c("NumericInputDialog", {
        attrs: { viewModel: _vm.numericInputDialog },
        on: {
          "update-value":
            _vm.handleMultipleAlternativesAttributeValueUpdateCommand,
        },
      }),
      _vm._v(" "),
      _c("MonthPickerDialog", {
        attrs: { viewModel: _vm.startDateMonthPicker },
        on: {
          "update-date": _vm.handleUpdateMultipleAlternativesStartDateCommand,
        },
      }),
      _vm._v(" "),
      _c("MonthPickerDialog", {
        attrs: { viewModel: _vm.commitmentDateMonthPicker },
        on: {
          "update-date":
            _vm.handleUpdateMultipleAlternativesCommitmentDateCommand,
        },
      }),
      _vm._v(" "),
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container-fluid",
              staticStyle: { "margin-top": "80px", "padding-top": "20px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("div", [
                    _c("h6", { staticClass: "text-muted mt-2" }, [
                      _vm._v(_vm._s(_vm.rm.TchProjectName)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex align-items-center" }, [
                    _c(
                      "h1",
                      {
                        staticStyle: {
                          "font-size": "2em",
                          "font-weight": "300",
                          color: "#33475b",
                          margin: "0",
                        },
                      },
                      [_vm._v(_vm._s(_vm.rm.AlternativesLabel) + ":")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown ml-2" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-link",
                          staticStyle: { "font-size": "2em", padding: "0" },
                          attrs: { "data-toggle": "dropdown" },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.viewDefName) +
                              " "
                          ),
                          _c("i", {
                            staticClass: "fa fa-caret-down",
                            staticStyle: {
                              "font-size": "0.7em",
                              "vertical-align": "middle",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu dropdown-menu-scrollable",
                          attrs: { role: "menu" },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  return _vm.setViewDef()
                                },
                              },
                            },
                            [_vm._v("All")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-divider" }),
                          _vm._v(" "),
                          _c("h6", { staticClass: "dropdown-header" }, [
                            _vm._v("Custom lists"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.rm.Views, function (v) {
                            return _c(
                              "a",
                              {
                                key: v.Id,
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.setViewDef(v.Id)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(v.Name))]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 text-right align-self-end" },
                  [
                    _c("div", { staticClass: "btn-group" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-outline-secondary dropdown-toggle",
                          staticStyle: { padding: "0.7em 2em" },
                          attrs: {
                            type: "button",
                            "data-toggle": "dropdown",
                            "aria-haspopup": "true",
                            "aria-expanded": "false",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        Actions\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "dropdown-menu" }, [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sanitizedHref",
                                rawName: "v-sanitizedHref",
                                value: `/#/import-alternatives/${_vm.workspaceId}/${_vm.projectId}/${_vm.rm.Id}`,
                                expression:
                                  "`/#/import-alternatives/${workspaceId}/${projectId}/${rm.Id}`",
                              },
                            ],
                            staticClass: "dropdown-item",
                          },
                          [_vm._v("Import")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: { click: _vm.handleExportAlternativesCommand },
                          },
                          [_vm._v("Export")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "dropdown-divider" }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sanitizedHref",
                                rawName: "v-sanitizedHref",
                                value: `/#/kanban-statuses/${_vm.workspaceId}/${_vm.projectId}`,
                                expression:
                                  "`/#/kanban-statuses/${workspaceId}/${projectId}`",
                              },
                            ],
                            staticClass: "dropdown-item",
                          },
                          [_vm._v("Edit statuses")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sanitizedHref",
                                rawName: "v-sanitizedHref",
                                value: `/#/alternatives-labels/${_vm.workspaceId}/${_vm.projectId}`,
                                expression:
                                  "`/#/alternatives-labels/${workspaceId}/${projectId}`",
                              },
                            ],
                            staticClass: "dropdown-item",
                          },
                          [_vm._v("Edit labels")]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        staticStyle: { padding: "0.7em 2em" },
                        attrs: { role: "button" },
                        on: { click: _vm.showAlternativeCreator },
                      },
                      [
                        _vm._v("\n                    Create "),
                        _c(
                          "span",
                          { staticStyle: { "text-transform": "lowercase" } },
                          [_vm._v(_vm._s(_vm.rm.AlternativeLabel))]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(0),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr", {
                staticStyle: { "border-color": "#bbb", margin: "20px 0 20px" },
              }),
              _vm._v(" "),
              _c(
                "nav",
                {
                  staticClass: "navbar navbar-light navbar-expand-md bg-light",
                  attrs: { role: "navigation" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "btn-group mr-2", attrs: { role: "group" } },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.showViewSettingsEditor },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-cog",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          attrs: {
                            type: "button",
                            title: "Collapse all columns",
                          },
                          on: { click: _vm.collapseAllColumns },
                        },
                        [_c("i", { staticClass: "fa fa-chevron-left" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          attrs: {
                            type: "button",
                            title: "Expand all columns",
                          },
                          on: { click: _vm.expandAllColumns },
                        },
                        [_c("i", { staticClass: "fa fa-chevron-right" })]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "btn-group mr-2", attrs: { role: "group" } },
                    [
                      _c("div", { staticClass: "btn-group" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            attrs: {
                              type: "button",
                              "data-toggle": "dropdown",
                              "aria-expanded": "false",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa-regular fa-square-check",
                            }),
                            _vm._v(
                              " (" +
                                _vm._s(_vm.selectedAlternatives?.length) +
                                ")\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "dropdown-menu dropdown-menu-scrollable",
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.selectAll()
                                  },
                                },
                              },
                              [_vm._v("Select all")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.unselectAll()
                                  },
                                },
                              },
                              [_vm._v("Unselect all")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.invertSelection()
                                  },
                                },
                              },
                              [_vm._v("Invert selection")]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "btn-group" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            attrs: {
                              type: "button",
                              "data-toggle": "dropdown",
                              "aria-expanded": "false",
                              disabled: !_vm.selectedAlternatives?.length,
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-pencil",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(" Edit\n                    "),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "dropdown-menu dropdown-menu-scrollable",
                          },
                          [
                            _c("h6", { staticClass: "dropdown-header" }, [
                              _vm._v("Edit selected"),
                            ]),
                            _vm._v(" "),
                            _vm.selectedAlternatives?.length
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: { click: _vm.showBulkStatusEditor },
                                      },
                                      [_vm._v("Status")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.bulkEditablelistAttributesBySection,
                                      function (items, section) {
                                        return _c(
                                          "div",
                                          { key: section },
                                          [
                                            section
                                              ? _c(
                                                  "h6",
                                                  {
                                                    staticClass:
                                                      "dropdown-header",
                                                  },
                                                  [_vm._v(_vm._s(section))]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm._l(items, function (attr) {
                                              return _c(
                                                "a",
                                                {
                                                  key: attr.Id,
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showBulkAttributeValueEditor(
                                                        attr
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(_vm._s(attr.Name))]
                                              )
                                            }),
                                          ],
                                          2
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-divider" }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: _vm.handleDeleteAlternativesCommand,
                                },
                              },
                              [_vm._v("Delete")]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "btn-group" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            attrs: {
                              type: "button",
                              "data-toggle": "dropdown",
                              "aria-expanded": "false",
                              disabled: !_vm.selectedAlternatives?.length,
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa-regular fa-calendar",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(" Dates\n                    "),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "dropdown-menu dropdown-menu-scrollable",
                          },
                          [
                            _c("h6", { staticClass: "dropdown-header" }, [
                              _vm._v("Edit selected"),
                            ]),
                            _vm._v(" "),
                            _vm.selectedAlternatives?.length
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: _vm.showBulkStartDateMonthPicker,
                                      },
                                    },
                                    [_vm._v("Start date")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click:
                                          _vm.showBulkCommitmentDateMonthPicker,
                                      },
                                    },
                                    [_vm._v("Commitment date")]
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          attrs: {
                            type: "button",
                            disabled: !_vm.selectedAlternatives?.length,
                          },
                          on: { click: _vm.showSelectedAlternativesComparison },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-balance-scale",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" Compare\n                "),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "form-inline my-2 my-lg-0 ml-auto",
                      attrs: { role: "search" },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchPhrase,
                            expression: "searchPhrase",
                          },
                        ],
                        staticClass: "form-control mr-sm-2",
                        attrs: {
                          type: "search",
                          placeholder: "Search",
                          "aria-label": "Search",
                        },
                        domProps: { value: _vm.searchPhrase },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.searchPhrase = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "btn-group" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-outline-secondary dropdown-toggle",
                        attrs: {
                          type: "button",
                          "data-toggle": "dropdown",
                          "aria-expanded": "false",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.orderByLabel) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "dropdown-menu dropdown-menu-right dropdown-menu-scrollable",
                        attrs: { role: "menu" },
                      },
                      [
                        _c("h6", { staticClass: "dropdown-header" }, [
                          _vm._v("Order by:"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.setOrderBy("name")
                              },
                            },
                          },
                          [_vm._v("Name")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.setOrderBy("modified")
                              },
                            },
                          },
                          [_vm._v("Date modified")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.setOrderBy("create date")
                              },
                            },
                          },
                          [_vm._v("Date created")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "dropdown-divider" }),
                        _vm._v(" "),
                        _vm._l(
                          _vm.attributesBySection,
                          function (items, section) {
                            return _c(
                              "div",
                              { key: section },
                              [
                                section
                                  ? _c(
                                      "h6",
                                      { staticClass: "dropdown-header" },
                                      [_vm._v(_vm._s(section))]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(items, function (attr) {
                                  return _c(
                                    "a",
                                    {
                                      key: attr.Id,
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          _vm.setOrderBy(attr.Id.toString())
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(attr.Name))]
                                  )
                                }),
                              ],
                              2
                            )
                          }
                        ),
                      ],
                      2
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "mt-3",
                  staticStyle: { height: "calc(100% - 60px)" },
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-lg-12" }, [
                      _c(
                        "div",
                        { staticStyle: { height: "calc(100vh - 300px)" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "overflow-x": "auto",
                                "overflow-y": "hidden",
                                height: "100%",
                                width: "100%",
                                "white-space": "nowrap",
                              },
                              on: { dragover: _vm.onDragOverContainer },
                            },
                            _vm._l(_vm.columns, function (column) {
                              return _vm.columns
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "inline-block",
                                        height: "100%",
                                      },
                                    },
                                    [
                                      column.IsCollapsed === true
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "card pointer mr-1",
                                              staticStyle: {
                                                width: "50px",
                                                height: "100%",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  column.IsCollapsed = false
                                                },
                                              },
                                            },
                                            [
                                              _vm._m(1, true),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "card-body bg-light",
                                                  class: {
                                                    "drag-over":
                                                      column.dragOver,
                                                  },
                                                  staticStyle: {
                                                    "overflow-x": "hidden",
                                                    "overflow-y": "auto",
                                                  },
                                                  on: {
                                                    dragover: function (
                                                      $event
                                                    ) {
                                                      $event.preventDefault()
                                                    },
                                                    dragenter: function (
                                                      $event
                                                    ) {
                                                      return _vm.onDragEnter(
                                                        $event,
                                                        column
                                                      )
                                                    },
                                                    dragleave: function (
                                                      $event
                                                    ) {
                                                      return _vm.onDragLeave(
                                                        $event,
                                                        column
                                                      )
                                                    },
                                                    drop: function ($event) {
                                                      return _vm.onDrop(
                                                        $event,
                                                        column
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticStyle: {
                                                        transform:
                                                          "rotate(90deg)",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(column.title)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      column.IsCollapsed === false
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "card mr-1",
                                              staticStyle: {
                                                width: "19vw",
                                                "min-width": "300px",
                                                height: "100%",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "card-header" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown float-right",
                                                    },
                                                    [
                                                      _vm._m(2, true),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "dropdown-menu dropdown-menu-right",
                                                          attrs: {
                                                            role: "menu",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "dropdown-item",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return column.selectAll()
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Select all"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "dropdown-item",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return column.invertSelection()
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Invert selection"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "dropdown-item",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return column.unselectAll()
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Unselect all"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "pointer",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          column.IsCollapsed = true
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(column.title)
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "card-body",
                                                  class: {
                                                    "drag-over":
                                                      column.dragOver,
                                                  },
                                                  staticStyle: {
                                                    "overflow-x": "hidden",
                                                    "overflow-y": "auto",
                                                  },
                                                  on: {
                                                    dragover: function (
                                                      $event
                                                    ) {
                                                      $event.preventDefault()
                                                    },
                                                    dragenter: function (
                                                      $event
                                                    ) {
                                                      return _vm.onDragEnter(
                                                        $event,
                                                        column
                                                      )
                                                    },
                                                    dragleave: function (
                                                      $event
                                                    ) {
                                                      return _vm.onDragLeave(
                                                        $event,
                                                        column
                                                      )
                                                    },
                                                    drop: function ($event) {
                                                      return _vm.onDrop(
                                                        $event,
                                                        column
                                                      )
                                                    },
                                                  },
                                                },
                                                _vm._l(
                                                  column.alternativesView,
                                                  function (a) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: a.Id,
                                                        attrs: {
                                                          draggable: true,
                                                        },
                                                        on: {
                                                          dragstart: function (
                                                            $event
                                                          ) {
                                                            return _vm.onDragStart(
                                                              $event,
                                                              a
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "tile1",
                                                            class:
                                                              _vm.getColorCssClass(
                                                                a.Id
                                                              ),
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "float-right",
                                                              },
                                                              [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.showAlternativeEditor(
                                                                            a.Id
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fa fa-pencil",
                                                                    }),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticStyle: {
                                                                  "white-space":
                                                                    "normal",
                                                                },
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        a.IsSelected,
                                                                      expression:
                                                                        "a.IsSelected",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    type: "checkbox",
                                                                  },
                                                                  domProps: {
                                                                    checked:
                                                                      Array.isArray(
                                                                        a.IsSelected
                                                                      )
                                                                        ? _vm._i(
                                                                            a.IsSelected,
                                                                            null
                                                                          ) > -1
                                                                        : a.IsSelected,
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        var $$a =
                                                                            a.IsSelected,
                                                                          $$el =
                                                                            $event.target,
                                                                          $$c =
                                                                            $$el.checked
                                                                              ? true
                                                                              : false
                                                                        if (
                                                                          Array.isArray(
                                                                            $$a
                                                                          )
                                                                        ) {
                                                                          var $$v =
                                                                              null,
                                                                            $$i =
                                                                              _vm._i(
                                                                                $$a,
                                                                                $$v
                                                                              )
                                                                          if (
                                                                            $$el.checked
                                                                          ) {
                                                                            $$i <
                                                                              0 &&
                                                                              _vm.$set(
                                                                                a,
                                                                                "IsSelected",
                                                                                $$a.concat(
                                                                                  [
                                                                                    $$v,
                                                                                  ]
                                                                                )
                                                                              )
                                                                          } else {
                                                                            $$i >
                                                                              -1 &&
                                                                              _vm.$set(
                                                                                a,
                                                                                "IsSelected",
                                                                                $$a
                                                                                  .slice(
                                                                                    0,
                                                                                    $$i
                                                                                  )
                                                                                  .concat(
                                                                                    $$a.slice(
                                                                                      $$i +
                                                                                        1
                                                                                    )
                                                                                  )
                                                                              )
                                                                          }
                                                                        } else {
                                                                          _vm.$set(
                                                                            a,
                                                                            "IsSelected",
                                                                            $$c
                                                                          )
                                                                        }
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "sanitizedHref",
                                                                          rawName:
                                                                            "v-sanitizedHref",
                                                                          value: `/#/alternative/dashboard/${_vm.workspaceId}/${_vm.projectId}/${a.Id}`,
                                                                          expression:
                                                                            "`/#/alternative/dashboard/${workspaceId}/${projectId}/${a.Id}`",
                                                                        },
                                                                      ],
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                        " +
                                                                        _vm._s(
                                                                          a.Name
                                                                        ) +
                                                                        "\n                                                    "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "h6",
                                                              {
                                                                staticClass:
                                                                  "font-italic mb-0",
                                                              },
                                                              [
                                                                _c("small", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.getColorLabel(
                                                                        a.Id
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e()
                            }),
                            0
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      {
        staticClass: "btn btn-lg btn-outline-secondary",
        attrs: {
          href: "https://www.transparentchoice.com/user-guide/pipeline",
          title: "User guide: Configure pipeline",
          target: "_blank",
        },
      },
      [_c("i", { staticClass: "fa fa-info", attrs: { "aria-hidden": "true" } })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "card-header" }, [
      _c("i", { staticClass: "fa fa-angle-right" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      { staticClass: "text-dark", attrs: { "data-toggle": "dropdown" } },
      [_c("i", { staticClass: "fa fa-ellipsis-h" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }